import { Grid, IconButton, Tooltip } from '@mui/material'
import { useLocation } from 'react-router-dom'
import { useCallback, useContext, useEffect, useState } from 'react'
import { MdAdd, MdArrowBack } from 'react-icons/md'
import { PendingActions } from '@mui/icons-material'
import { GlobalContext } from '../../../App'
import Programa from '../../../components/Programa/Programa'
import PrimeTable from '../../../components/PrimeTable'
import Edicao from './Edicao'
import { FaFileAlt, FaFileSignature } from 'react-icons/fa'
import ModalDocumento from './ModalDocumento'
import { useModal } from '../../../components/Utils/UseModal'

const ReceitasAvulsas = () => {
  const location = useLocation()
  const [preenchido, setPreenchido] = useState(null)
  const { localAtendimento } = useContext(GlobalContext)
  const openModal = useModal(ModalDocumento)

  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [refresh, setRefresh] = useState(0)

  const voltar = useCallback(() => {
    setTela('lista')
    setDados(undefined)
    setRefresh((prev) => prev + 1)
  }, [])

  const handleClick = (linha, preenchido) => {
    if (linha?.[7] === '1') return

    setDados(linha)
    setPreenchido(preenchido || null)
    setTela('edicao')
  }

  // Check for state from navigation (e.g., prescrever from PDV)
  useEffect(() => {
    const stateAcCliente = location.state?.acCliente
    const stateConteudo = location.state?.dsConteudo
    if (stateAcCliente && stateConteudo) {
      setPreenchido({
        acCliente: stateAcCliente,
        dsConteudo: stateConteudo,
      })
      setTela('edicao')
      // Clear state to avoid re-populating on refresh
      window.history.replaceState({}, document.title)
    }
  }, [location.state])

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton
              onClick={() => {
                setDados(undefined)
                setTela('edicao')
              }}
            >
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'edicao':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela, voltar])

  const handleAbrirOriginal = async (item) => {
    await openModal({
      nmDocumento: item?.[8],
      token: item?.[9],
      assinado: false,
    })
  }

  const handleAbrirAssinado = async (item) => {
    await openModal({
      nmDocumento: item?.[8],
      token: item?.[9],
      assinado: true,
    })
  }

  return (
    <Programa codigo="CtrlReceitaAvulsa" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {localAtendimento !== undefined && localAtendimento !== null && (
              <PrimeTable
                codigo="CtrlReceitaAvulsa"
                action="lista"
                rows={10}
                habSearch
                head={['Nome', 'Tipo', 'Inclusão', 'Original', 'Assinado']}
                line={(item) => [
                  item[4],
                  item[1],
                  item[2],
                  <FaFileAlt
                    key={`alt-${item[0]}`}
                    style={{ cursor: 'pointer' }}
                    onClick={(e) => {
                      e.stopPropagation()
                      handleAbrirOriginal(item)
                    }}
                  />,
                  item[7] === '1' ? (
                    <FaFileSignature
                      key={`sign-${item[0]}`}
                      style={{ cursor: 'pointer', marginLeft: 8 }}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleAbrirAssinado(item)
                      }}
                    />
                  ) : (
                    <Tooltip
                      title="Aguardando assinatura"
                      key={`pending-${item[0]}`}
                    >
                      <IconButton
                        size="small"
                        color="warning"
                        aria-label="Documento pendente de assinatura"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <PendingActions fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  ),
                ]}
                collumnsDateHour={[2]}
                onRowSelect={handleClick}
                refresh={refresh}
              />
            )}
          </Grid>
        </Grid>
      ) : (
        <Edicao dados={dados} preenchido={preenchido} voltar={voltar} />
      )}
    </Programa>
  )
}

export default ReceitasAvulsas
